import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const consentRequestLayoutApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConsentRequestLayouts: builder.query({
      query: () => {
        return {
          url: `/cmp/consent_request_layouts`,
        }},
      providesTags: (result = [], error, args) => [{ type: 'ConsentRequestLayout', id: 'LIST' } ],
    }),
    updateConsentRequestLayout: builder.mutation({
      query: ({id, layout}) => {
        return {
          url: `/cmp/consent_request_layouts/${id}`,
          method: 'PUT',
          body: layout
        }},
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {id}) => [
        { type: 'ConsentRequestLayout', id: 'LIST' },
        { type: 'ConsentRequestLayout', id: id }],
    }),
    getConsentRequestLayoutPreview: builder.query({
      query: ({id, lang, appId}) => {
        let queryString = `?lang=${lang}`
        if (appId) {
          queryString += `&appId=${appId}`
        }
        return {
          url: `/cmp/consent_request_layouts/${id}/preview${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'ConsentRequestLayout', id: `preview:${JSON.stringify(arg)}` }],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetConsentRequestLayoutsQuery,
  useUpdateConsentRequestLayoutMutation,
  useGetConsentRequestLayoutPreviewQuery
} = consentRequestLayoutApiSlice
